export default {
    template: [
        'SUGGESTION_TEMPLATE',
        data => ({
            suggestion: data.suggestion,
            type: data.type,
        }),
    ],

    GET: {},
};
